import { getCustomMainColor } from "@/core/services/layout.service";

export const customCssVarsMixin = {
  computed: {
    cssVars() {
      return {
        "--custom-primary-color": getCustomMainColor(),
      };
    },
  },
};
